<nav
  class="s01-navigation"
  [attr.aria-expanded]="isOpen"
  [ngClass]="{ 'is-active': isOpen }"
  [cdkTrapFocus]="isOpen"
>
  <div class="links-modal" #linksModalRef>
    <ul id="nav-controls" [attr.aria-hidden]="!isOpen" class="buttons-list">
      <li class="nav-list-item" *ngFor="let link of links">
        <a
          class="nav-anchor"
          [routerLink]="link.link"
          [queryParams]="params"
          [class.active]="link.isActive"
          (click)="handleLinkClick(link.feature)"
        >
          <span class="nav-button">{{ link.copy }}</span>
        </a>
      </li>
    </ul>
    <div class="compare-button-wrapper">
      <app-a02-comparison-button
        [location]="compareButtonLocation"
        [isSmall]="true"
      ></app-a02-comparison-button>
    </div>
  </div>
  <div class="button-menu-wrapper">
    <button
      #hamburgerButtonRef
      (click)="onMenuButtonClick()"
      class="button-menu"
      aria-haspopup="true"
      aria-controls="nav-controls"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="
        isOpen
          ? copy[jsonKey.NAVIGATION_CLOSE_ARIA_LABEL]
          : copy[jsonKey.NAVIGATION_OPEN_ARIA_LABEL]
      "
    >
      <div class="icon-container">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          xml:space="preserve"
          fill="currentColor"
        >
          <g class="icon lines">
            <path
              d="M21.8,6.8H2.2c-0.7,0-1.3-0.6-1.3-1.3v0c0-0.7,0.6-1.3,1.3-1.3h19.5c0.7,0,1.3,0.6,1.3,1.3v0C23.1,6.3,22.5,6.8,21.8,6.8z"
            />
            <path
              d="M21.8,13.2H2.2c-0.7,0-1.3-0.6-1.3-1.3v0c0-0.7,0.6-1.3,1.3-1.3h19.5c0.7,0,1.3,0.6,1.3,1.3v0
         C23.1,12.6,22.5,13.2,21.8,13.2z"
            />
            <path
              d="M21.8,19.7H2.2c-0.7,0-1.3-0.6-1.3-1.3v0c0-0.7,0.6-1.3,1.3-1.3h19.5c0.7,0,1.3,0.6,1.3,1.3v0
         C23.1,19.2,22.5,19.7,21.8,19.7z"
            />
          </g>
          <g class="icon cross">
            <path
              d="M18,19.7L4.2,5.9c-0.5-0.5-0.5-1.3,0-1.8l0,0c0.5-0.5,1.3-0.5,1.8,0l13.8,13.8c0.5,0.5,0.5,1.3,0,1.8l0,0
         C19.3,20.2,18.5,20.2,18,19.7z"
            />
            <path
              d="M19.8,5.9L6,19.7c-0.5,0.5-1.3,0.5-1.8,0l0,0c-0.5-0.5-0.5-1.3,0-1.8L18,4.1c0.5-0.5,1.3-0.5,1.8,0l0,0
         C20.3,4.6,20.3,5.4,19.8,5.9z"
            />
          </g>
        </svg>
      </div>
    </button>
  </div>
</nav>
